<template>
  <!-- <footer class="page-footer font-small blue"> -->
  <footer class="page-footer font-small">
    <!-- Copyright -->
    <div class="footer-copyright text-center py-3">
      {{ $t("title.copyRight") }} :
      <a :href="$t('title.urlTrangDaoTao')" target="_blank">
        {{ $t("title.footer") }}
      </a>
    </div>
    <!-- Copyright -->
  </footer>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
</style>
